// Service Worker Registration and PWA Install

let deferredInstallPrompt: any = null;
let controllerChangeHandlerAttached = false;

export async function registerServiceWorker(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    console.warn('Service Worker not supported');
    return;
  }

  try {
    const registration = await navigator.serviceWorker.register('/sw.js', {
      scope: '/',
    });

    console.log('Service Worker registered:', registration.scope);

    // If a new SW takes control, reload to avoid running stale cached HTML/JS.
    if (!controllerChangeHandlerAttached) {
      controllerChangeHandlerAttached = true;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        window.location.reload();
      });
    }

    // Check for updates periodically.
    setInterval(() => {
      registration.update();
    }, 60 * 60 * 1000);

    // If there's already an updated worker waiting, prompt immediately.
    if (registration.waiting && navigator.serviceWorker.controller) {
      showUpdateNotification(registration);
    }

    // Listen for updates.
    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          showUpdateNotification(registration);
        }
      });
    });
  } catch (error) {
    console.error('Service Worker registration failed:', error);
  }
}

function showUpdateNotification(registration: ServiceWorkerRegistration): void {
  // Avoid stacking banners.
  if (document.querySelector('.update-banner')) return;

  const updateBanner = document.createElement('div');
  updateBanner.className = 'update-banner';
  updateBanner.innerHTML = `
    <div class="update-content">
      <span>Update available</span>
      <button id="update-btn" class="update-button">Refresh</button>
    </div>
  `;
  document.body.appendChild(updateBanner);

  document.getElementById('update-btn')?.addEventListener('click', () => {
    // Tell the waiting worker to activate, then controllerchange will reload.
    registration.waiting?.postMessage({ type: 'SKIP_WAITING' });
    // Fallback if something goes wrong.
    setTimeout(() => window.location.reload(), 500);
  });
}

// Install prompt handling
export function setupInstallPrompt(): void {
  window.addEventListener('beforeinstallprompt', (e) => {
    // Prevent the mini-infobar from appearing.
    e.preventDefault();

    // Store the event for later use.
    deferredInstallPrompt = e;

    // Show custom install button.
    showInstallButton();
  });

  // Detect if app was installed.
  window.addEventListener('appinstalled', () => {
    console.log('PWA installed successfully');
    deferredInstallPrompt = null;
    hideInstallButton();
  });
}

function showInstallButton(): void {
  const installButton = document.getElementById('install-app-btn');
  if (installButton) {
    installButton.style.display = 'flex';
  }
}

function hideInstallButton(): void {
  const installButton = document.getElementById('install-app-btn');
  if (installButton) {
    installButton.style.display = 'none';
  }
}

export async function promptInstall(): Promise<void> {
  if (!deferredInstallPrompt) {
    console.log('Install prompt not available');
    return;
  }

  deferredInstallPrompt.prompt();

  const { outcome } = await deferredInstallPrompt.userChoice;
  console.log(`Install prompt outcome: ${outcome}`);

  deferredInstallPrompt = null;
  hideInstallButton();
}

export function isAppInstalled(): boolean {
  const isStandalone = window.matchMedia('(display-mode: standalone)').matches;
  const isIOSStandalone = (navigator as any).standalone === true;
  return isStandalone || isIOSStandalone;
}

